export enum KahunApiEvents {
  status = "kahun_session_status",
  widget = "kahun_widget_state",
  debug = "kahun_debug",
}

export function dispatchKahunEvent(eventtype: KahunApiEvents, data?: object) {
  if (window?.dispatchEvent) {
    const event = new Event(eventtype);
    if (data) Object.assign(event, data);
    // console.log("window.dispatch", event);
    window.dispatchEvent(event);
    if (window["kahunWidgetInstance"])
      window["kahunWidgetInstance"].dispatchEvent(event); //if widget instance exists dispatch the event for it too
  }
}
